export default __webpack_public_path__ + "static/media/Hotel.81ed05cc.png";